<template>
  <div class="UpiInfoPop">
    <div class="cardBorder">
      <div class="card">
        <div class="title">{{ $t('lang.UPIandBankCardInfo.UPIInfo') }}</div>
        <div class="blackCard">
          <div class="stepTitle">{{ $t('lang.UPIandBankCardInfo.stepTitle') }}</div>
          <div class="steps" :key='index' v-for="(step,index)  in $t('lang.UPIandBankCardInfo.steps')">{{ step }}</div>
          <div class="video-btn" @click="seeVideo"><img :src="play" class="play" alt=""/> {{ $t('lang.UPIandBankCardInfo.video') }}</div>
        </div>
        <div class="formBox">
          <div class="item">
            <div class="label">{{ $t('lang.UPIandBankCardInfo.UPIID') }}</div>
            <input v-model="value" @focus="inputFocus" @input="doOnInput()"
                   @blur="inputBlur" class="input" :placeholder="$t('lang.UPIandBankCardInfo.UPIIDPlaceholder')"
                   type="text">
            <div class="historyListBox" :style="{'maxHeight':isShowHistoryBox?'30.555vw':'0vw'}">
              <div @click="setValue(item)" :class="value===item?'listItemActive':'listItem'" v-for="(item, index) in historyList" :key="index">{{item}}</div>
            </div>
            <div class="tip" v-if="!isOK">{{ $t('lang.UPIandBankCardInfo.formatBankNameTip') }}</div>
          </div>
          <div @click="submitInfo" class="submit">{{ $t('lang.account.submit') }}</div>
        </div>
        <img @click="close" src="../../assets/images/accountInfo/close.png" alt="" class="close">
      </div>
    </div>
    <UpiVideo v-if="videoShow" :handleClose="closeVideo"
              url="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Homebanner/zzw6f4kkxe0cht1n9uqeuis6550cpzikvideo.mp4"
    />
  </div>
</template>

<script>
import play from '@/assets/images/account/play.svg'
import UpiVideo from '@/components/UpiVideo/index'

export default {
  name: 'index',
  data () {
    return {
      play,
      isShowHistoryBox: false,
      isOK: true,
      value: '',
      historyList: [],
      videoShow: false
    }
  },
  components: {
    UpiVideo
  },
  mounted () {
    if (localStorage.getItem('UPIInfoDraftList')) {
      this.historyList = JSON.parse(localStorage.getItem('UPIInfoDraftList'))
    }
  },
  methods: {
    seeVideo () {
      this.videoShow = true
    },
    closeVideo () {
      this.videoShow = false
    },
    submitInfo () {
      this.validateInput()
      if (this.value && this.isOK) {
        this.historyList = this.historyList
          .filter(item => item !== this.value)
          .concat([this.value])
          .slice(-3)
        localStorage.setItem('UPIInfoDraftList', JSON.stringify(this.historyList))
        this.$emit('commitUPIInfo', this.value)
        this.value = ''
        this.close()
      }
    },
    validateInput () {
      if (this.value && /^[a-zA-Z0-9._-]{3,60}@[a-zA-Z0-9.-]{3,20}$/.test(this.value)) {
        this.isOK = true
      } else {
        this.isOK = false
      }
    },
    setValue (item) {
      this.value = item
      this.doOnInput()
    },
    close () {
      this.value = ''
      this.$emit('close')
    },
    doOnInput () {
      if (this.value && /^[a-zA-Z0-9._-]{3,60}@[a-zA-Z0-9.-]{3,20}$/.test(this.value)) {
        this.isOK = true
      }
    },
    inputFocus () {
      this.isShowHistoryBox = true
    },
    inputBlur () {
      this.isShowHistoryBox = false
    }
  }
}
</script>

<style lang="less" scoped>
.UpiInfoPop{
  height: 100vh;
  width: 100vw;
  background-color: rgba(0,0,0,0.6);
  //background-color: red;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;

  .cardBorder {
    position: relative;
    background-color: rgb(115, 115, 115);
    width: 86.666vw;
    height: 121.388vw;
    border-radius: 4.166vw;
    padding: 0.2vw;
    animation: scaleUp 0.2s ease-out;
    @keyframes scaleUp {
      from {
        transform: scale(0);
        opacity: 0;
      }
      to {
        transform: scale(1);
        opacity: 1;
      }
    }

    .card {
      background-color: rgb(26, 27, 26);
      border-radius: 4.166vw;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 4.8vw 6.72vw;
      gap: 2vw;
      margin-bottom: 16vw;

      .close {
        height: 4.733vw;
        width: 4.333vw;
        position: absolute;
        bottom: -12vw;
      }

      .title {
        font-size: 5.833vw;
        font-weight: bold;
        color: #fff;
      }

      .blackCard {
        position: relative;
        background: #090909;
        width: 76.28vw;
        height: 47.5vw;
        margin-top: 3vw;
        margin-bottom: 6.111vw;
        border-radius: 1.6667vw;
        padding: 4.8vw 3.75vw;

        .stepTitle {
          font-family: Inter;
          font-weight: 600;
          font-size: 4.2vw;
          line-height: 100%;
          text-transform: capitalize;
          color: #C2C2C2;
          margin-bottom: 3vw;
        }

        .steps {
          font-family: Inter;
          font-weight: 400;
          font-size: 3.888vw;
          line-height: 5vw;
          color: #6E6E6E;
        }

        .video-btn {
          position: absolute;
          top: 4.5vw;
          right: 5vw;
          width: 20.277vw;
          line-height: 6.111vw;
          font-family: Inter;
          font-weight: 600;
          font-size: 3.333vw;
          text-transform: capitalize;
          color: #CBCBCB;
          border: 0.333vw solid #CBCBCB;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 2.5vw;
          border-radius: 1.111vw;

          img {
            width: 3.56vw;
            height: auto;
            margin-right: 2vw;
          }
        }
      }

      .formBox {
        width: 74.886vw;
        height: 9.444vw;
        display: flex;
        flex-direction: column;
        gap: 6vw;

        .item {
          position: relative;
          display: flex;
          flex-direction: column;
          gap: 2.777vw;

          .label {
            color: #F0D4A6;
            font-size: 4.166vw;
          }

          .input {
            height: 9.44vw;
            width: 74.886vw;
            border-radius: 0.8333vw;
            padding: 3.413vw;
            border: 1px solid rgb(134, 120, 96);
            color: #FFFFFF;
            font-size: 3.472vw;
          }

          input::placeholder {
            color: #404040;
            font-size: 3.472vw;
          }

          .historyListBox {
            position: absolute;
            top: 18vw;
            width: 74.886vw;
            background-color: #0E0F0E;
            display: flex;
            flex-direction: column;
            font-size: 3.33vw;
            color: #828282;
            overflow: hidden;
            overflow-y: scroll;
            transition: all 0.17s linear;
            z-index: 1;

            .listItem {
              height: 8.313vw;
              padding: 2.58vw 2.361vw;
              display: flex;
              align-items: center;
            }

            .listItemActive {
              height: 8.313vw;
              padding: 2.58vw 2.361vw;
              display: flex;
              align-items: center;
              background-color: rgb(59, 59, 59);
              color: #CACACA;
            }
          }

          .tip {
            position: absolute;
            bottom: -9.75vw;
            color: #B20000;
            font-size: 3.472vw;
            z-index: 0;
          }
        }

        .submit {
          margin-top: 6.5vw;
          height: 9.444vw;
          line-height: 9.444vw;
          width: 74.886vw;
          background: linear-gradient(to right, #EFD6AD 0%, #DAB67C 100%);
          border-radius: 1.388vw;
          color: #000000;
          font-weight: bold;
          font-size: 4.1666vw;
          text-align: center;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/UpiInfoPop/index.vue